import { QThemeProvider, QContainer, AnalysisRequestSubmissionComplete } from '@kw/quokka-ui';
import { styled } from '@mui/material/styles';
import { useContext } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { BackgroundProgressBar } from '../../BackgroundProgressBar/BackgroundProgressBar';
import BackButton from '../../shared/BackButton';
import { RequestAnalysisInfoContext } from './RequestAnalysisInfoContext';

export default function SubmissionQueueConfirmation() {
  const { numberOfSubmissions, submittedAt } = useContext(RequestAnalysisInfoContext);
  const navigate = useNavigate();

  // submittedAt is only set once a submission succeeds, so its absence means the page was opened directly or reloaded
  if (!submittedAt) {
    return <Navigate to="/applications/request-analysis" replace />;
  }

  return (
    <QThemeProvider>
      <QContainer
        sx={{
          paddingTop: '16px',
          paddingBottom: '0px',
          maxWidth: '100% !important',
          display: 'flex',
          flexDirection: 'column',
          rowGap: 2,
          overflow: 'auto',
        }}
      >
        <BackgroundProgressBar />
        <BackButton href="/applications/request-analysis" text="Back to Request Analysis" />
        <SubmissionWrapper>
          <AnalysisRequestSubmissionComplete
            numberOfSubmissions={numberOfSubmissions}
            submittedAt={submittedAt}
            onReturnToRequestAnalysis={() => navigate('/applications/request-analysis')}
            onGoToApplicationsList={() => navigate('/applications')}
          />
        </SubmissionWrapper>
      </QContainer>
    </QThemeProvider>
  );
}

const SubmissionWrapper = styled('div')`
  width: 100%;
  margin: 20px auto 0;
`;
